import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { type ReactNode } from 'react'
import { LaneOrRegionPanel } from './CarrierProfile.types'

export interface LaneOrRegionLocationProps {
  panelType: LaneOrRegionPanel
  header: string
  activePanel: LaneOrRegionPanel
  onPanelChange: (panel: LaneOrRegionPanel) => void
  children: ReactNode
}

const LaneOrRegionDialogPanel = ({
  panelType,
  header,
  activePanel,
  onPanelChange,
  children,
}: LaneOrRegionLocationProps): ReactNode => (
  <Accordion expanded={activePanel === panelType} onChange={() => onPanelChange(panelType)}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="p4" color="primary">
        {header}
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Stack direction="column" spacing={1}>
        {children}
      </Stack>
    </AccordionDetails>
  </Accordion>
)

export default LaneOrRegionDialogPanel
